// Column guidance shown as hover tooltips on the bulk upload dropzone.
// Keep in sync with the columns each Bulk*ViewSet reads in pages_app/views.py.

const REGION_COLUMNS = [
  { name: "region", description: "One of: Nation, AC, PC, State, District (case-insensitive).", example: "State" },
  { name: "state", description: "Required for region State/AC/PC/District. Must match an existing State.", example: "Uttar Pradesh" },
  { name: "ac", description: "Required only when region = AC.", example: "Lucknow West" },
  { name: "pc", description: "Required only when region = PC.", example: "Lucknow" },
  { name: "district", description: "Required only when region = District.", example: "Lucknow" },
];

const POLITICAL_PARTY_COLUMN = {
  name: "political_party",
  description: "Must match an existing political party.",
  example: "BJP",
};

const COUNTRY_COLUMN = {
  name: "country_name",
  description: "Must match an existing country.",
  example: "India",
};

const PLATFORM_COLUMN_INFO = {
  Facebook: [
    { name: "page_id", description: "Facebook Page ID, wrapped in underscores.", example: "_1234567890_" },
    { name: "page_name", description: "Display name of the page.", example: "Sample News Page" },
    POLITICAL_PARTY_COLUMN,
    { name: "page_category", description: "Top-level category for the page.", example: "News" },
    { name: "page_subcategory", description: "Sub-category for the page.", example: "Regional News" },
    ...REGION_COLUMNS,
    COUNTRY_COLUMN,
  ],
  Instagram: [
    { name: "insta_handles", description: "Instagram handle (unique identifier).", example: "sample_handle" },
    { name: "insta_name", description: "Display name of the account.", example: "Sample Account" },
    POLITICAL_PARTY_COLUMN,
    { name: "insta_category", description: "Top-level category for the account.", example: "News" },
    { name: "insta_subcategory", description: "Sub-category for the account.", example: "Regional News" },
    ...REGION_COLUMNS,
    COUNTRY_COLUMN,
  ],
  Twitter: [
    { name: "username", description: "X/Twitter username (unique identifier).", example: "sample_user" },
    { name: "handle_name", description: "Display name for the handle.", example: "Sample Handle" },
    POLITICAL_PARTY_COLUMN,
    { name: "handle_category", description: "Top-level category for the handle.", example: "News" },
    { name: "handle_subcategory", description: "Sub-category for the handle.", example: "Regional News" },
    ...REGION_COLUMNS,
  ],
  YouTube: [
    { name: "channel_id", description: "YouTube Channel ID (unique identifier).", example: "UCxxxxxxxxxxxxxxxxxxxxxx" },
    { name: "channel_name", description: "Display name of the channel.", example: "Sample Channel" },
    POLITICAL_PARTY_COLUMN,
    { name: "category", description: "Top-level category for the channel.", example: "News" },
    { name: "subcategory", description: "Sub-category for the channel.", example: "Regional News" },
    ...REGION_COLUMNS,
  ],
  "SMAR Facebook": [
    { name: "page_id", description: "Facebook Page ID to add to the selected SMAR group.", example: "_1234567890_" },
  ],
  "SMAR Instagram": [
    { name: "insta_handle", description: "Instagram handle to add to the selected SMAR group.", example: "sample_handle" },
  ],
  "SMAR Twitter": [
    { name: "handle", description: "X/Twitter handle to add to the selected SMAR group.", example: "sample_user" },
  ],
  "SMAR YouTube": [
    { name: "channel_id", description: "YouTube Channel ID to add to the selected SMAR group.", example: "UCxxxxxxxxxxxxxxxxxxxxxx" },
  ],
};

export function getColumnInfo(platform) {
  return PLATFORM_COLUMN_INFO[platform] || PLATFORM_COLUMN_INFO.Facebook;
}
